(function() {
  'use strict';

  function ImportCSVController(
    $q,
    $rootScope,
    $scope,
    $translate,
    Router,
    Form,
    Importer,
    LocalizationService,
    Notify,
    Utils
  ) {
    var ctrl = this;
    ctrl.dateFormat = LocalizationService.getDateTimeFormat('datetime');

    ctrl.lastCompletedImport = null;
    ctrl.mapping = [];
    ctrl.entryUniqueness = {};
    ctrl.files = {};
    ctrl.dataFileOptions = {
      accept: ['csvs'],
      multiple: false,
      required: true,
      storeSingle: true
    };

    ctrl.isBasicFormFullyFilledIn = false;
    function setIsBasicFormFullyFilledIn(importDoc) {
      if (!importDoc || !importDoc.docType) {
        ctrl.isBasicFormFullyFilledIn = false;
        return false;
      }

      var docType = importDoc.docType;
      var result = false;

      if (docType === 'user') {
        result = true;
      } else if (docType === 'event') {
        if (ctrl.operation === 'submit') {
          result = !!(importDoc.eventTypeId && importDoc.sectionId);
        } else {
          result = !!importDoc.eventTypeId;
        }
      } else if (docType === 'booking') {
        result = !!importDoc.bookingOptionId;
      }

      ctrl.isBasicFormFullyFilledIn = result;
      return result;
    }

    ctrl.partHasLocking = function(part) {
      return ['hard', 'soft'].includes(part);
    };

    function getExtraFromImport(importData) {
      if (importData.docType === 'event') {
        if (ctrl.operation === 'submit') {
          return { eventTypeId: importData.eventTypeId, sectionId: importData.sectionId };
        }
        return { eventTypeId: importData.eventTypeId };
      } else if (importData.docType === 'booking') {
        return {
          bookingItemId: importData.bookingItemId,
          bookingOptionId: importData.bookingOptionId
        };
      }

      return {};
    }

    // Fetches kzFields when all required basic attributes are set
    function refreshKzFields() {
      if (!ctrl.isBasicFormFullyFilledIn) {
        ctrl.kzFields = undefined;
        return;
      }

      var extra = getExtraFromImport($scope.import);
      Importer.getKzFields($scope.import.docType, extra)
        .then(function(kzFields) {
          ctrl.kzFields = kzFields;
        })
        .catch(Utils.showError);
    }

    // Only parses the file and sets fileColumns
    ctrl.fileSaved = function(files) {
      if (_.isEmpty(files)) {
        return;
      }

      var fileModel = files[0];
      if (fileModel.file === undefined) {
        return;
      }

      ctrl.parseFile(fileModel.file).then(function(columns) {
        ctrl.fileColumns = columns;
      });
    };

    ctrl.parseFile = function(file) {
      var q = $q.defer();
      var reader = new FileReader();

      reader.readAsText(file);
      reader.onload = function() {
        q.resolve(reader.result.split(/\r?\n/)[0].split(','));
      };
      reader.onerror = function() {
        console.log(reader.error);
        q.reject(reader.error);
      };
      return q.promise;
    };

    function getActionForm(docType, operation, userPermissions) {
      if (operation === 'submit') {
        return new Form([]);
      }

      function getActionOptions() {
        var options = [];
        var allUsersPerms = [];
        _.forEach(userPermissions, function(perms) {
          _.forEach(perms, function(perm) {
            allUsersPerms.push(perm);
          });
        });
        // var docType = $scope.import.docType;
        var createPerms = ['users.create', 'events.create', 'events.create.own'],
            updatePerms = [
            'users.edit',
            'roles.assign',
            'credential.manage',
            'events.edit',
            'events.edit.own',
            'events.editCompleted',
            'events.editCompleted.own',
            'goals.manage'
            ];
        options = [
          {
            _id: 'createOnlyIfNotExists',
            key: 'createOnlyIfNotExists',
            name: $translate.instant(
              'Search for existing data, create new records which do not exist,' +
              ' do not update existing data'
            ),
            permsToHave: createPerms
          },
          {
            _id: 'createOrUpdate',
            key: 'createOrUpdate',
            name: $translate.instant(
              'Search for existing data, create new records which do not exist,' +
              ' update existing data'
            ),
            permsToHave: createPerms.concat(updatePerms),
            hideForDocTypes: ['booking']
          },
          {
            _id: 'updateOnly',
            key: 'updateOnly',
            name: $translate.instant(
              'Search for existing data, do not create new records,' +
              ' update existing data'
            ),
            permsToHave: updatePerms,
            hideForDocTypes: ['booking']
          },
          {
            _id: 'forceCreate',
            key: 'forceCreate',
            name: $translate.instant(
              'Create all records in the file, do not check for existing data'
            ),
            permsToHave: createPerms,
            hideForDocTypes: ['user']
          }
        ];
        return _.filter(options, function(opt) {
          return !_.isEmpty(_.intersection(allUsersPerms, opt.permsToHave)) &&
            (_.isUndefined(opt.hideForDocTypes) ||
              _.indexOf(opt.hideForDocTypes, docType) === -1);
        });
      }

      return new Form([
        {
          id: 'action',
          type: 'discrete',
          label: $translate.instant('How should the import behave?'),
          required: true,
          disabled: !ctrl.partUnlocked.options,
          defaultValue: 'createOnlyIfNotExists',
          options: getActionOptions()
        }
      ]);
    }

    function getBasicForm() {
      function onChangeBasicAttrs() {
        delete $scope.import.entry_uniqueness;
        ctrl.mapping = [];

        if (!$scope.import.file) {
          ctrl.fileColumns = undefined;
          $rootScope.$broadcast('ResetFileInput');
        }

        // Update isBasicFormFullyFilledIn first, then refresh kzFields
        setIsBasicFormFullyFilledIn($scope.import);
        refreshKzFields();
      }

      function getEventTypeSections(eventTypeId) {
        if (!eventTypeId) {
          return [];
        }

        var selectedItem = _.find(ctrl.availableEventTypes, { id: eventTypeId });
        if (!selectedItem) {
          return [];
        }

        return _.map(selectedItem.sections || [], function(section) {
          return {
            _id: section.id,
            key: section.id,
            name: $translate.instant('Section') + ' ' + section.sectionIdx
          };
        });
      }

      function getBookingOptions(bookingItemId) {
        if (!bookingItemId) {
          return [];
        }

        var selectedItem = _.find(ctrl.availableBookingItems, { id: bookingItemId });
        return _.map(selectedItem.bookingOptions || [], function(option) {
          return { _id: option.id, key: option.id, name: option.name };
        });
      }

      var fields = [
        {
          id: 'name',
          type: 'string',
          label: $translate.instant('Import task title'),
          disabled: !ctrl.partUnlocked.header,
          required: true,
          helpText: $translate.instant(
            'Provide a label for this import so you can find it later' +
            ' in the import list.'
          )
        }
      ];

      // Add originName only if originId is present
      if ($scope.import && $scope.import.originId) {
        fields.push({
          id: 'originName',
          type: 'string',
          label: $translate.instant('Origin name'),
          disabled: !ctrl.partUnlocked.header,
          required: true,
          onChange: function() {
            onChangeBasicAttrs();
          }
        });
      }

      var docTypeSpecificFields = [];
      if (ctrl.model.docType === 'event') {
        // eventTypeId is always available for events (no hideExpression)
        docTypeSpecificFields.push({
          id: 'eventTypeId',
          type: 'discrete',
          label: $translate.instant('Event Type'),
          disabled: !ctrl.partUnlocked.header,
          required: true,
          options: _.map(ctrl.availableEventTypes, function(eventType) {
            var name = eventType.name + ' (v' + eventType.version + ') ';
            return { _id: eventType.id, key: eventType.id, name: name };
          }),
          onChange: function() {
            delete $scope.import.sectionId;
            onChangeBasicAttrs();
          }
        });

        // Add sectionId only when eventTypeId is set and operation is submit
        if ($scope.import && $scope.import.eventTypeId && ctrl.operation === 'submit') {
          docTypeSpecificFields.push({
            id: 'sectionId',
            type: 'discrete',
            label: $translate.instant('Section Id'),
            disabled: !ctrl.partUnlocked.header,
            required: true,
            options: getEventTypeSections($scope.import.eventTypeId),
            onChange: function() {
              onChangeBasicAttrs();
            }
          });
        }
      } else if (ctrl.model.docType === 'booking') {
        // bookingItemId is always available for bookings (no hideExpression)
        docTypeSpecificFields.push({
          id: 'bookingItemId',
          type: 'discrete',
          label: $translate.instant('Booking Items'),
          disabled: !ctrl.partUnlocked.header,
          required: true,
          options: _.map(ctrl.availableBookingItems, function(bookingItem) {
            return { _id: bookingItem.id, key: bookingItem.id, name: bookingItem.name };
          }),
          onChange: function() {
            delete $scope.import.bookingOptions;
            onChangeBasicAttrs();
          }
        });

        // Add bookingOptionId only when bookingItemId is set
        if ($scope.import && $scope.import.bookingItemId) {
          docTypeSpecificFields.push({
            id: 'bookingOptionId',
            type: 'discrete',
            label: $translate.instant('Booking Options'),
            disabled: !ctrl.partUnlocked.header,
            required: true,
            options: getBookingOptions($scope.import.bookingItemId),
            onChange: function() {
              onChangeBasicAttrs();
            }
          });
        }
      }

      fields.push.apply(fields, docTypeSpecificFields);
      return new Form(fields);
    }

    function getEmailsForm(docType) {
      if (docType === 'booking') {
        return new Form([]);
      }

      return new Form([
        {
          id: 'sendEmails',
          type: 'boolean',
          label: $translate.instant('Would you like to send emails?'),
          defaultValue: false,
          required: true,
          disabled: !ctrl.partUnlocked.options
        }
      ]);
    }

    function getlinkExistingEventsToTargetsForm() {
      return new Form([
        {
          id: 'linkExistingEventsToTargets',
          type: 'boolean',
          label: $translate.instant('Link existing events to targets?'),
          required: true,
          defaultValue: false
        }
      ]);
    }

    function getAttachedFileForm() {
      return new Form([
        {
          id: 'attachedFiles',
          type: 'file',
          label: $translate.instant('Upload your zip file containing the files to attach'),
          required: false,
          fileOptions: {
            accept: ['zip'],
            sizeLimit: 1000,
            fileLimit: 1,
            storeSingle: true
          }
        }
      ]);
    }

    function getApplyLastGoalSetVersionForm() {
      return new Form([
        {
          id: 'applyLastGoalSetVersion',
          type: 'boolean',
          label: $translate.instant('Apply last goal set version?'),
          required: true,
          defaultValue: false
        }
      ]);
    }

    function updateEventTypeFlags() {
      if (ctrl.model.docType !== 'event' || !ctrl.availableEventTypes) {
        return;
      }

      ctrl.eventTypesContainingGoals = [];
      ctrl.eventTypesContainingFileFields = [];

      _.forEach(ctrl.availableEventTypes, function(eventType) {
        var sections = eventType.sections || [];
        if (!sections.length) {
          return;
        }

        if (ctrl.operation === 'import') {
          // For import: use the first section of each event type
          var firstSection = sections[0];
          if (firstSection.containsFileField) {
            ctrl.eventTypesContainingFileFields.push(eventType.id);
          }
          if (firstSection.goalSection) {
            ctrl.eventTypesContainingGoals.push(eventType.id);
          }
        } else if (ctrl.operation === 'submit') {
          // For submit: only consider the selected section of the selected event type
          if (
            $scope.import &&
            $scope.import.eventTypeId === eventType.id &&
            $scope.import.sectionId
          ) {
            var selectedSection = _.find(sections, { id: $scope.import.sectionId });
            if (selectedSection) {
              if (selectedSection.containsFileField) {
                ctrl.eventTypesContainingFileFields.push(eventType.id);
              }
              if (selectedSection.goalSection) {
                ctrl.eventTypesContainingGoals.push(eventType.id);
              }
            }
          }
        }
      });

      // Update containsFileField for the "Upload your zip file..." visibility
      if ($scope.import && $scope.import.eventTypeId) {
        ctrl.containsFileField =
          ctrl.eventTypesContainingFileFields.indexOf($scope.import.eventTypeId) > -1;
      } else {
        ctrl.containsFileField = false;
      }
    }

    function initWatches() {
      const handleDocTypeWatch = ($scope, ctrl, watchField) => {
        $scope.$watchCollection(`import.${watchField}`, function(newId) {
          if (_.isUndefined(newId)) {
            return;
          }

          // Recreate the docTypeForm to update the fields
          ctrl.basicForm = getBasicForm();

          // Recompute flags whenever these change
          updateEventTypeFlags();
        });
      };

      if ($scope.import.docType === 'event') {
        handleDocTypeWatch($scope, ctrl, 'eventTypeId');
        if (ctrl.operation === 'submit') {
          handleDocTypeWatch($scope, ctrl, 'sectionId');
        }
      } else if ($scope.import.docType === 'booking') {
        handleDocTypeWatch($scope, ctrl, 'bookingItemId');
      }
    }

    function isUnlocked(part) {
      if (!ctrl.model.stateOptions) {
        return true;
      }

      return _.indexOf(['soft', 'hard'], ctrl.model.stateOptions.locked[part]) === -1;
    }

    function init() {
      // Re-initialisation (e.g. switching bulk action) must show the loading
      // indicator again while the docType specific data is fetched.
      ctrl.loaded = false;

      // todo: this probably could be improved.
      let title;
      if (ctrl.model.originId) {
        title = $translate.instant('New import');
      } else if (ctrl.id) {
        title = $translate.instant('Retry') + ' ' +
          ctrl.bulkActionName + ' ' +
          $translate.instant('named') + ' "' + ctrl.model.name + '"';
      } else {
        title = $translate.instant('New import');
      }
      ctrl.title = title;

      $scope.import = ctrl.model || {};
      ctrl.mapping = ctrl.model.mapping || [];
      ctrl.entryUniqueness = ctrl.model.entry_uniqueness;
      ctrl.partUnlocked = {
        header: isUnlocked('header'),
        options: isUnlocked('options'),
        files: isUnlocked('files')
      };
      // delete $scope.import.mapping;

      setIsBasicFormFullyFilledIn($scope.import);

      var docType = ctrl.model.docType;

      ctrl.containsFileField = false;
      var docTypeSpecificProm = $q.when();
      if (docType === 'user') {
        ctrl.containsFileField = true;
      } else if (docType === 'event') {
        docTypeSpecificProm = Importer.getAvailableEventTypes(ctrl.operation)
          .then(function(availableEventTypes) {
            ctrl.availableEventTypes = availableEventTypes;
            updateEventTypeFlags();
          });
      } else if (docType === 'booking') {
        docTypeSpecificProm = Importer.getAvailableBookingItems()
          .then(function(availableBookingItems) {
            ctrl.availableBookingItems = availableBookingItems;
            ctrl.bookingOptionsContainingFileFields = [];
            _.forEach(ctrl.availableBookingItems, function(bookingItem) {
              _.forEach(bookingItem.bookingOptions, function(bookingOption) {
                if (bookingOption.containsFieldFields) {
                  ctrl.bookingOptionsContainingFileFields.push(bookingOption.id);
                }
              });

              ctrl.containsFileField = ctrl.bookingOptionsContainingFileFields
                                              .indexOf($scope.import.bookingOptionId) > -1;
            });
          });
      }

      $q.all([Importer.getAllUserPermissions(), docTypeSpecificProm])
        .then(function(result) {
          ctrl.userPermissions = result[0];

          ctrl.basicForm = getBasicForm();
          ctrl.actionForm = getActionForm(
            $scope.import.docType,
            ctrl.operation,
            ctrl.userPermissions
          );
          ctrl.emailsForm = getEmailsForm(ctrl.model.docType);
          ctrl.linkExistingEventsToTargetsForm = getlinkExistingEventsToTargetsForm();
          ctrl.applyLastGoalSetVersionForm = getApplyLastGoalSetVersionForm();
          ctrl.attachedFilesForm = getAttachedFileForm();
          ctrl.fileColumns = $scope.import.fileColumns;
          if (ctrl.model.options?.action) {
            var extra = getExtraFromImport(ctrl.model);

            // In case of event we make sure we have the eventTypeId
            if (ctrl.model.docType !== 'event' || !_.isEmpty(extra)) {
              return Importer.getKzFields(ctrl.model.docType, extra)
                .then(kzFields => {
                  ctrl.kzFields = kzFields;
                });
            }
          }
        })
        .then(function() {
          return Importer.getExistingImportsByOrigin($scope.import.originId, 'completed');
        })
        .then(function(existingImports) {
          // sort by startdate descending and take the last one
          ctrl.lastCompletedImport = _.chain(existingImports)
                                      .sortBy('-startDate')
                                      .first()
                                      .value();

          initWatches();
        })
        .catch(Utils.showError)
        .finally(function() {
          ctrl.loaded = true;
        });
    }

    // this.$onInit = function() {
    //   init();
    // };

    this.$onChanges = function() {
      init();
    };

    function isValid() {
      var notValidFields = [];
      if (_.isEmpty($scope.import.name)) {
        notValidFields.push($translate.instant('Import task title is missing'));
      }

      // docType
      var docTypeValid = !_.isEmpty($scope.import.docType);
      if ($scope.import.docType === 'event') {
        docTypeValid = !_.isEmpty($scope.import.eventTypeId);

        // check if the event type is still published.
        var eventTypeIds = _.map(ctrl.availableEventTypes, function(eventType) {
          return eventType.id;
        });
        if (_.indexOf(eventTypeIds, $scope.import.eventTypeId) === -1) {
          var msg = $translate.instant(
            'The selected event type is now archived,' +
            ' please choose a published one.'
          );
          notValidFields.push(msg);
        }
      }

      if (!docTypeValid) {
        notValidFields.push($translate.instant('The type of data'));
      }

      if (_.isEmpty($scope.import.file)) {
        notValidFields.push($translate.instant('Please select a file'));
      }

      // mapping
      // required mapping
      var mappingValid = true;
      if ($scope.import.options.action !== 'updateOnly') {
        if (!_.isEmpty(ctrl.mapping)) {
          var requiredFields = _.chain(ctrl.kzFields)
            .filter(function(field) {
              return field.required === true &&
                !(field.restricted || {}).by;
            })
            .map(function(field) {
              return field._id;
            })
            .value();

          var mappedFields = _.map(ctrl.mapping, function(_map) {
            return _map.fieldId;
          });

          _.forEach(requiredFields, function(requiredField) {
            if (_.indexOf(mappedFields, requiredField) === -1) {
              mappingValid = false;
              return;
            }
          });
        } else {
          mappingValid = false;
        }
      }

      if (!mappingValid) {
        notValidFields.push($translate.instant('Some required fields were not matched'));
      }

      if ($scope.import.options.action !== 'forceCreate' && _.isEmpty(ctrl.entryUniqueness)) {
        notValidFields.push($translate.instant(
          'You have chosen to search for existing data but no columns' +
          ' have been selected'
        ));
      }

      return notValidFields;
    }

    ctrl.previewEmail = function(docType, action) {
      var emails = {
        user: {
          create: {
            title: $translate.instant(
              'Users will receive this email when the profile is created' +
              ' only if you defined a local username and password'
            ),
            text: $translate.instant(
              'You have received this email because you have been added' +
              ' as a new risr/advance user.'
            ) + '\n\n' +
              $translate.instant('Here are your credentials:') + '\n' +
              ' - ' + $translate.instant('Username:') + ' {{ username }}\n' +
              ' - ' + $translate.instant('Password: set it by clicking here') + '\n'
          },
          update: {
            title: $translate.instant(
              'Users will not receive any emails when the profile is updated'
            )
          }
        },
        event: {
          create: {
            title: $translate.instant('Users will receive this email if the event is completed.'),
            text: $translate.instant('An event has just been completed on your timeline.') + '\n' +
              $translate.instant('Click here to view the full event') + ' {{ NAME_OF_THE_EVENT }}'
          },
          update: {
            title: $translate.instant('Users will not receive any emails when the title is updated')
          }
        }
      };

      if (_.isUndefined(docType) || _.isUndefined(action)) {
        return;
      }

      var content = emails[docType][action];

      Utils.swal({
        title: content.title,
        text: content.text || '',
        type: 'info',
        showCancelButton: false,
        allowEscapeKey: true,
        confirmButtonText: $translate.instant('OK'),
        closeOnConfirm: true
      });
    };

    function startImport(importDoc, dryrun) {
      var name = importDoc.name,
          docType = importDoc.docType,
          bulkFileName = importDoc.file.filename,
          bulkFileColumns = ctrl.fileColumns,
          dataFile = importDoc.file,
          attachedFiles = importDoc.attachedFiles,
          extra = getExtraFromImport(importDoc),
          mapping = ctrl.mapping,
          entryUniqueness = ctrl.entryUniqueness,
          options = importDoc.options,
          stateOptions = importDoc.stateOptions,
          operation = ctrl.operation;

      var origin = {};
      if (importDoc.originName) {
        origin = {
          id: importDoc.originId,
          name: importDoc.originName
        };
      }

      if (_.isUndefined(dryrun)) {
        dryrun = true;
      }

      Importer.importFile(
        name,
        docType,
        extra,
        bulkFileName,
        bulkFileColumns,
        dataFile,
        attachedFiles,
        mapping,
        entryUniqueness,
        options,
        stateOptions,
        origin,
        operation,
        ctrl.id,
        dryrun
      )
        .then(function(response) {
          Notify.success($translate.instant('Import created'));
          Router.navigate(['/bulk-actions/view', response.task_id]);
        })
        .catch(Utils.showError);
    }

    ctrl.startImport = function(importDoc, dryrun) {
      var errors = isValid();
      if (!_.isEmpty(errors)) {
        var text = '';
        _.forEach(errors, function(error) {
          text += error + ' \n';
        });
        Utils.swal({
          title: $translate.instant('They are some errors in the form:') + ' \n' + text,
          type: 'warning',
          showCancelButton: false,
          confirmButtonText: $translate.instant('OK')
        });
        return;
      }

      if (dryrun) {
        startImport(importDoc, dryrun);
      } else {
        Utils.swal({
          title: $translate.instant('Are you sure you would like to run this import for real?'),
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: $translate.instant('OK')
        },
        function(isConfirm) {
          if (isConfirm) {
            startImport(importDoc, dryrun);
          }
        });
      }
    };

    ctrl.downloadCSVTemplate = function(importDoc) {
      var docType = importDoc.docType,
          extra = getExtraFromImport(importDoc);
      return Importer.downloadCSVTemplate(docType, extra);
    };

    ctrl.unlockPart = function(part) {
      ctrl.partUnlocked[part] = true;
      if (part === 'header') {
        ctrl.basicForm = getBasicForm();
      } else if (part === 'options') {
        ctrl.actionForm = getActionForm(
          $scope.import.docType,
          ctrl.operation,
          ctrl.userPermissions
        );
        ctrl.emailsForm = getEmailsForm($scope.import.docType);
        ctrl.linkExistingEventsToTargetsForm = getlinkExistingEventsToTargetsForm();
      } else if (part === 'files') {
        ctrl.attachedFilesForm = getAttachedFileForm();
      }
    };
    ctrl.redirectView = function(id) {
      Router.navigate(['/bulk-actions/view', id]);
    };
  }

  ImportCSVController.$inject = [
    '$q',
    '$rootScope',
    '$scope',
    '$translate',
    'Router',
    'FormsService',
    'ImporterService',
    'LocalizationService',
    'NotifyService',
    'UtilsService',
    'AsyncTasksService'
  ];

  angular.module('component.bulkActions')
    .component('importCsv', {
      templateUrl: 'app/components/bulk-actions/import-csv/components/import-CSV.html',
      controller: ImportCSVController,
      bindings: {
        id: '<',
        bulkActionName: '<',
        model: '<',
        operation: '<'
      }
    });

  angular.module('component.bulkActions')
    .directive('ngUploadChange', function() {
      return {
        scope: {
          ngUploadChange: '&'
        },
        link: function($scope, $element) {
          $element.on('change', function(event) {
            $scope.$apply(function() {
              $scope.ngUploadChange({ $event: event });
            });
          });
          $scope.$on('$destroy', function() {
            $element.off();
          });

          $scope.$on('ResetFileInput', function() {
            $element.val(null);
          });
        }
      };
    });
})();
